import { useEffect, useState } from 'react';

export default function useClientPagination<T>(items: T[], pageSize: number, resetKey: unknown) {
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  const totalCount = items.length;
  const pageCount = Math.max(1, Math.ceil(totalCount / pageSize));
  const safePage = Math.min(page, pageCount);
  const startIndex = (safePage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, totalCount);

  return {
    pagedItems: items.slice(startIndex, endIndex),
    rangeLabel: totalCount === 0 ? '0 / 0件' : `${startIndex + 1}-${endIndex} / ${totalCount}件`,
    canGoPrev: safePage > 1,
    canGoNext: safePage < pageCount,
    goPrev: () => setPage(Math.max(1, safePage - 1)),
    goNext: () => setPage(Math.min(pageCount, safePage + 1)),
  };
}
